<script lang="ts">
  import clsx from 'clsx'
  import withPreventDefault from '../../../../utils/withPreventDefault'

  type Props = {
    onclick: () => void
    hidden: boolean
    label: string
    icon?: any
  }

  const { onclick, hidden, label, icon }: Props = $props()

  const onClick = (e: MouseEvent) =>
    withPreventDefault(e, () => {
      onclick()
    })
</script>

<li class="pl-3 w-full">
  <button
    class={clsx(
      'flex items-center justify-between w-full',
      hidden ? 'hidden' : 'flex',
    )}
    onclick={(e) => onClick(e)}
  >
    <div class="flex items-center gap-2">
      {#if icon}<div class="h-6 w-6 flex justify-center items-center">
          {@render icon?.()}
        </div>{/if}
      <span>{label}</span>
    </div>
  </button>
</li>
